module.exports = __webpack_public_path__ + "img/about-page-icon-crypto.0fbe1ed6.svg";